export default __webpack_public_path__ + "static/media/audio_31_piedras.87143852.mp3";